import React from 'react'

export interface IExpose {
  hasBeenProvided: boolean
  showNetPrice: boolean
  setShowNetPrice: (updatedShowNetPrice: boolean) => void
  showMyPrice: boolean
  refetchPriceRulesSettings?: () => void
}

export const ShowNetPriceContext = React.createContext<IExpose>({
  hasBeenProvided: false,
  showNetPrice: true,
  setShowNetPrice: () => {},
  showMyPrice: false,
  refetchPriceRulesSettings: () => {}
})

export const useShowNetPriceContext = (): IExpose => {
  const v = React.useContext(ShowNetPriceContext)
  if (!v?.hasBeenProvided) {
    console.error('useShowNetPriceContext must be used within an ShowNetPriceContextProvider')
  }

  return v
}

export const { Consumer: ShowNetPriceContextConsumer } = ShowNetPriceContext
